import React, { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath, Position } from '@xyflow/react';
import { Typography, Box, Tooltip } from '@mui/material';

// Read-only edge renderer shared by the Workflow Library view ('actionEdge')
// and the instance journey view (completed/active/upcoming edges).
// Status edges color the stroke and label by status; view-mode edges color the
// label by whether an action is associated and show the full action on hover.

const edgeStatusColorMap = {
    'completedEdge': 'gray',
    'activeEdge': 'lightgreen',
    'upcomingEdge': 'orange',
    'blockedEdge': '#d32f2f'
};

export default memo((edgeDetails) => {
    const { id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, type } = edgeDetails;

    const [edgePath, labelX, labelY] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
    // Decision/approval branches leave from side handles; push their labels outward so the
    // two branches' labels don't overlap when they meet at the same node.
    const labelOffsetX = sourcePosition === Position.Left ? '-100%' : sourcePosition === Position.Right ? '0%' : '-50%';

    const statusColor = edgeStatusColorMap[type];
    const pillColor = statusColor || (data?.action ? 'orange' : 'gray');

    const label = (
        <div
            style={{
                position: 'absolute',
                transform: `translate(${labelOffsetX}, -50%) translate(${labelX}px, ${labelY}px)`,
                pointerEvents: 'all',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: pillColor,
                    padding: '2px 6px',
                    borderRadius: '14px',
                    fontSize: '8px',
                }}
            >
                <Typography sx={{ fontSize: '8px', color: 'black', marginRight: '4px' }}>
                    {data?.action
                        ? `${data.action.length > 40 ? data.action.substring(0, 40) + '...' : data.action}`
                        : 'No action associated'
                    }
                </Typography>
            </Box>
        </div>
    );

    return (
        <>
            <BaseEdge id={id} path={edgePath} style={statusColor ? { stroke: statusColor } : undefined} />
            <EdgeLabelRenderer>
                {statusColor ? label : <Tooltip title={data?.action}>{label}</Tooltip>}
            </EdgeLabelRenderer>
        </>
    );
});
